<template>
    <div
        class="health-card"
        @click="view(card)"
        v-if="2 === card.medicalCardType"
    >
        <div class="details">
            <div>
                <div class="name">
                    {{ card.name }}
                </div>
                <div>
                    <div class="tag" v-if="card.isDefault">
                        <span>默认</span>
                    </div>
                </div>
            </div>
            <div>
                <div class="type">
                    {{
                        2 === card.medicalCardType ? "电子健康卡" : "院内就诊卡"
                    }}
                </div>
                <div class="idNo">
                    {{ `${card.idNo.slice(0, 4)}****${card.idNo.slice(-4)}` }}
                </div>
            </div>
        </div>

        <div class="img">
            <van-icon name="qr" />
        </div>
    </div>
    <div v-else class="medical-card"></div>
</template>

<script>
export default {
    methods: {
        view(card) {
            const { $router } = this;
            $router.push({
                path: '/medical_card/manage_card',
                query: {
                    cardId: card.id
                }
            });
        }
    },
    props: {
        card: {
            type: Object,
            default: () => { },
            required: true
        }
    }
}
</script>

<style lang="less" scoped>
.health-card {
    margin: 0 0.4rem;
    background: url(../../assets/img/health_card.png) no-repeat;
    background-size: 100% 100%;
    height: 3.066667rem;
    border-radius: 0.13rem;
    position: relative;
    padding: 0.266667rem;
    display: flex;

    .details {
        flex: 1;
        padding: 0.133333rem 0.266667rem;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        height: 100%;

        .name {
            font-weight: bold;
            font-size: 0.426667rem;
            color: @black-color;
            line-height: 0.853333rem;
        }

        .tag {
            line-height: 0.266667rem;

            span {
                padding: 0.053333rem 0.213333rem;
                font-size: 0.266667rem;
                border-radius: 0.08rem;
                line-height: 0.64rem;
                color: @primary-color;
                background-color: @white-color;
                border: 0.026667rem solid @primary-color;
            }
        }

        .type {
            font-size: 0.32rem;
            color: @grey-color;
            line-height: 0.64rem;
            opacity: 0.5;
        }

        .idNo {
            font-size: 0.373333rem;
            color: @black-color;
            font-weight: 600;
            line-height: 0.746667rem;
        }
    }

    .img {
        width: 2.666667rem;
        height: 100%;
        position: relative;

        > i {
            font-size: 1.333333rem;
            color: @white-color;
            opacity: 0.5;
            position: absolute;
            bottom: 0;
            right: 0;
        }
    }
}
</style>